import Beat from './beat';

export default Beat;



// WEBPACK FOOTER //
// ./src/views/pages/Annotation/components/Beat/index.js